import { BsSliders } from 'react-icons/bs';
import { RxSlider } from 'react-icons/rx';
import React from 'react';
import { styled } from 'styled-components';
import { COLORS } from '../../../styles/style';
import { Popover } from 'antd';
import { ExceptionsModalDisplayType } from '../../../screens/Modals/CategoryExceptionsModal/categoryExceptionsModalLib';
import CategoryExceptionsListing from '../CategoryExceptionsListing/CategoryExceptionsListing';

const IconWrapper = styled.span`
  display: flex;
  margin-right: 0.25rem;
`;

interface ExceptionIconContainerProps {
  $hasException: boolean;
}

export const ExceptionIconContainer = styled.span<ExceptionIconContainerProps>`
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => (p.$hasException ? COLORS.PRIMARY : 'inherit')};
`;

interface ExceptionIconProps {
  categoryId: number;
  hasException: boolean;
  subcategoryHasException: boolean;
}

/**
 * Indicates that a category or its subcategories have exceptions.
 * Displays a different icon if both the category and its subcategories have exceptions or
 * only the subcategories have exceptions.
 * @param hasException
 * @param subcategoryHasException
 * @param exceptions
 * @param categoryId
 * @constructor
 */
const ExceptionIcon: React.FC<ExceptionIconProps> = ({
  hasException,
  subcategoryHasException,
  categoryId,
}) => {
  const show = hasException || subcategoryHasException;
  const Icon = hasException && subcategoryHasException ? BsSliders : RxSlider;

  return (
    <IconWrapper>
      {show && (
        <ExceptionIconContainer $hasException={hasException}>
          <Popover
            content={
              <CategoryExceptionsListing
                startCategoryId={categoryId}
                displayType={ExceptionsModalDisplayType.CATEGORY}
                fullHeight={false}
              />
            }
          >
            <Icon />
          </Popover>
        </ExceptionIconContainer>
      )}
    </IconWrapper>
  );
};

export default ExceptionIcon;
